import { useTileDataContext } from '~/context/srp/TileDataContext';
import { InventoryTypeId } from '../../types';

export const useNoVehicle = () => {
  const { tileData } = useTileDataContext();

  return Boolean(!tileData?.vehicleId);
};

export const useImageUrl = () => {
  const { tileData } = useTileDataContext();

  if (!tileData) {
    return '';
  }

  const hasJellyBeanUrl = Boolean(tileData.jellyBeanMobileUrl);
  const hasStockNumber = Boolean(tileData.stockNumber);
  const isWip = tileData.vehicleInventoryType === InventoryTypeId.WIP;

  if (!hasStockNumber && !hasJellyBeanUrl) {
    return `${process.env.CVNA_APP_ASSETS_CDN}/search-assets/noevox.png`;
  }

  return isWip
    ? (tileData.jellyBeanMobileUrl as string)
    : `${process.env.CVNA_VEX_FASTLY_IMAGE_URL}/${tileData.stockNumber}/standardizedHero.jpg`;
};

export const useAltText = () => {
  const { tileData } = useTileDataContext();

  const make = tileData?.make;
  const model = tileData?.model;
  const year = tileData?.year;

  return make && model && year ? `${year} ${make} ${model}` : '';
};
